import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import React from "react";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import { getPersonFullName } from "utils/person";

interface Props {
  userRoles: racehorse360.IUserRole[];
  onRemove: (userRole: racehorse360.IUserRole) => void;
}
// All commented lines in this file will be needed after the read / unread comment functionality is added

const UserRoleList = (props: Props) => {
  const { userRoles, onRemove } = props;

  const renderTableHead = () => {
    return (
      <TableRow>
        <TableCell>Role</TableCell>
        <TableCell>Facility</TableCell>
        <TableCell>Trainer</TableCell>
        <TableCell>Actions</TableCell>
      </TableRow>
    );
  };

  const renderRows = (requests: racehorse360.IUserRole[]) => {
    return requests.map(item => (
      <TableRow key={item.id}>
        <TableCell>{item.role.name}</TableCell>
        <TableCell>{item.facility?.name}</TableCell>
        <TableCell>
          {item.trainer &&
            `${getPersonFullName(item.trainer)} (${item.trainer.type})`}
        </TableCell>
        <TableCell>
          <Button
            size={"small"}
            onClick={() => onRemove(item)}
            startIcon={<DeleteForeverIcon />}
          >
            Delete
          </Button>
        </TableCell>
      </TableRow>
    ));
  };

  return (
    <TableContainer>
      <Table>
        <TableBody>
          {renderTableHead()}
          {renderRows(userRoles)}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default UserRoleList;
